import Vue from 'vue'

const state = {
  incomplete: [],
  concept: [],
  confirmation: [],
  confirmed: [],
  articles: []
}

const getters = {
  allReceipts (state) {
    let receipts = [...state.incomplete, ...state.concept, ...state.confirmation, ...state.confirmed]
    return receipts
  },
  incompleteReceipts: (state) => state.incomplete,
  conceptReceipts: (state) => state.concept,
  confirmationReceipts: (state) => state.confirmation,
  confirmedReceipts: (state) => state.confirmed,
  receiptArticles: (state) => state.articles,
  confirmedAndUnusedReceipts (state) {
    const receipts = state.confirmed.filter((object) => {
      const purchase = !object.purchase || object.purchase === 'CORRECTIONS'
      const sale = !object.sale || object.sale === 'CORRECTIONS'

      return !(!purchase && !sale)
    })

    return receipts
  },
  unusedReceiptsPurchase (state) {
    const receipts = state.confirmed.filter((object) => {
      return object.state === 'CONFIRMED' && (!object.purchase || object.purchase === 'CORRECTIONS')
    })

    return receipts
  },
  unusedReceiptsSales (state) {
    const receipts = state.confirmed.filter((object) => {
      return object.state === 'CONFIRMED' && (!object.sale || object.sale === 'CORRECTIONS')
    })

    return receipts
  }
}

const actions = {
  async getAllReceipts ({dispatch}, force = false) {
    await dispatch('getIncompleteReceipts', force)
    await dispatch('getConceptReceipts', force)
    await dispatch('getConfirmationReceipts', force)
    await dispatch('getConfirmedReceipts', force)
  },
  async getIncompleteReceipts ({commit, getters}, force = false) {
    if (getters.incompleteReceipts.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/receipts/incomplete')
    commit('setIncompleteReceipts', body.data)
  },
  async deleteReceipt ({dispatch}, id) {
    await Vue.http.delete('/receipt/' + id)
    await dispatch('getAllReceipts', true)
  },
  async getConceptReceipts ({commit, getters}, force = false) {
    if (getters.conceptReceipts.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/receipts/concept')
    commit('setConceptReceipts', body.data)
  },
  async getConfirmationReceipts ({commit, getters}, force = false) {
    if (getters.confirmationReceipts.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/receipts/confirmation')
    commit('setConfirmationReceipts', body.data)
  },
  async getConfirmedReceipts ({commit, getters}, force = false) {
    if (getters.confirmedReceipts.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/receipts/confirmed')
    commit('setConfirmedReceipts', body.data)
  },
  async saveReceiptConcept ({dispatch}, concept) {
    await Vue.http.post('/receipts/concept', concept)
    await dispatch('getConceptReceipts', true)
    await dispatch('getConfirmationReceipts', true)
  },
  async receiptReadyForConfirmation (ctx, id) {
    await Vue.http.post('/change/state/receipt', {
      state: 'confirm',
      id
    })
  },
  async setReceiptState ({commit}, {id, state}) {
    await Vue.http.post('/change/state/receipt', {
      state,
      id
    })
  },
  async getReceiptArticles ({commit}) {
    const {body} = await Vue.http.get('/receipt/articles')
    commit('setReceiptArticles', body.data)
  }
}

const mutations = {
  setIncompleteReceipts (state, receipts) {
    state.incomplete = receipts
  },
  setConceptReceipts (state, receipts) {
    state.concept = receipts
  },
  setConfirmationReceipts (state, receipts) {
    state.confirmation = receipts
  },
  setConfirmedReceipts (state, receipts) {
    state.confirmed = receipts
  },
  setReceiptArticles (state, articles) {
    state.articles = articles
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/receipts.js